// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lb8B","toggle":"styles_toggle__1EBKA","preview":"styles_preview__Q_cr0"};